import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'
import { supplierConvertPath } from 'routes'
import { ProcurementContainer, ProcurementBody } from 'routes/ProcurementSystem/styled'
import { PRListCont } from './styled'
import { fetchSuppliers } from 'ducks/supplier'
import { columns } from './AttributeData'
import { MainBodyContent, CustomButton, SearchList, TablePagination } from 'components'

// import r from 'reactotron-react-js'

const PurchaseRequisition = (props) => {
  const { listSupplier, valueForm } = props
  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(() => {
    window.scrollTo(0, 0)
    props.fetchSuppliers({ page: 1, size: pageSize })
  }, [])

  return (
    <MainBodyContent headerTitle='Supplier'>
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList 
            placeholder='Vendor Name' 
            fetchAPI={props.fetchSuppliers} 
            formSearchName='formSearchSupplier' 
            filterDate 
            filterStatus 
            hideProject={true}
            pageSize={userPageSize}
          />
          <PRListCont>
            <ReactTable
              data={Object.keys(listSupplier).length > 0 ? listSupplier.data : []}
              columns={columns.list}
              defaultPageSize={userPageSize}
              noDataText='No data supplier request.'
              previousText={<Icon name='arrow alternate circle left' />}
              nextText={<Icon name='arrow alternate circle right' />}
              className='-striped -highlight'

              PaginationComponent={TablePagination}
              pages={Object.keys(listSupplier).length > 0 ? listSupplier.totalPage : 0}
              currentPage={Object.keys(listSupplier).length > 0 ? listSupplier.page : 0}
              onPageChange={(pageIndex) => {
                props.fetchSuppliers({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.fetchSuppliers({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      props.history.push(supplierConvertPath(rowInfo.original.id))
                      // if ([0, 5].indexOf(Number(rowInfo.original.status)) >= 0) {
                      //   props.history.push(vmEditPath(rowInfo.original.id))
                      // } else {
                      //   props.history.push(vmDetailPath(rowInfo.original.id))
                      // }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </PRListCont>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => ({
  valueForm: getFormValues('formSearchSupplier')(state),
  listSupplier: state.supplier.listSupplier.data,
})

const mapDispatchToProps = {
  fetchSuppliers
}

const contForm = reduxForm({
  form: 'formSearchSupplier',
  enableReinitialize: true,
})(PurchaseRequisition)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)